export default __webpack_public_path__ + "static/media/play.f12bd474.svg";